/**
 * @namespace GlobalMethods
 */
export default {
    /**
     * @param {String} status Дата в виде строки
     * @returns {Date|Error} Ошибка или дата в формате дд.мм.гггг
     * 
     * @memberof GlobalMethods
     */
    toDate: (status) => {
        try {
            const dateProposal = new Date(status);
            const day =  Number(dateProposal.getDate()) < 10 ? `0${dateProposal.getDate()}` : dateProposal.getDate();
            const month =  Number(dateProposal.getMonth() + 1) < 10 ? `0${dateProposal.getMonth() + 1}` : dateProposal.getMonth() + 1;
            const date = `${day}.${month}.${dateProposal.getFullYear()}`;
    
            return date;
        } catch (error) {
            this.$toasted.show(`Произошла ошибка! ${error}`, { type: 'error', duration: 3000 });
            
            return error;
        }
    },
}